export default __webpack_public_path__ + "static/media/spoonSpices.7a8099f9.jpeg";